// extracted by mini-css-extract-plugin
export default {"loginTopImageLayout":"Login_loginTopImageLayout__CGWBT","title":"Login_title__vcg8P","amprimary":"Login_amprimary__GSuVm"};